import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as actions from '../store/actions';

import { ActionButton, CommandButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

// import logo from '../assets/images/hydroviz_logo_2.png';

const PAGES = [
  {
    path: '/',
    match: '',
    name: 'About'
  },
  {
    path: '/map',
    match: 'map',
    name: 'Map'
  },
  {
    path: '/charts',
    match: 'charts',
    name: 'Charts'
  },
  {
    path: '/por',
    match: 'por',
    name: 'Period of Record'
  }
]

class Header extends Component {

  render() {
    const path = this.props.location.pathname.split('/')[1];
    return (
      <header className='header'>
        <div className='left'>
          <div style={{display: 'flex', alignItems: 'center', marginRight: '40px'}}>
            <Icon iconName='Drop' style={{margin: '0px 8px', color: '#0078d4', fontSize: '32px'}}></Icon>
            <span className='ms-fontSize-42' style={{color:'#0078d4', fontSize: '24px'}}>HydroViz</span>
          </div>
          {/* <img className='logo' src={ logo } alt='hydroviz_logo'/> */}
          <div className='links'>
            {
              PAGES.map(each => {
                let { path, name } = each
                let classes = ['nav-button'];
                let splitPath = this.props.location.pathname.split('/');
                if(each.match === splitPath[1]){ classes.push('active') };
                return (
                  <div key={each.path} className={classes.join(' ')} onClick={() => this.props.history.push(path)}>{ name }</div>
                )
              })
            }
          </div>
          {
            path && (
              <ActionButton
                className='help'
                iconProps={{ iconName: 'UnknownSolid', style:{fontSize: '32px'} }}
                onClick={() => this.props.setModal('Help')}
                title="Help"
                ariaLabel="Help"
              />
            )
          }
        </div>
        <div className='right'>
          <CommandButton
            iconProps={{iconName: 'Contact'}}
            menuProps={{items: [
              {
                key: 'sign out',
                text: 'Sign out',
                onClick: () => this.props.setAuth(false)
              }
            ]}}
            text={this.props.user.email}
          />
        </div>
      </header>
    );
  }
};

const mapStateToProps = state => {
	return {
    modal: state.modal.modal,
    show: state.nav.show,
    user: state.auth.user
	};
};

const mapDispatchToProps = dispatch => {
	return {
    setModal: (modal) => dispatch(actions.setModal(modal)),
    toggleNav: (show) => dispatch(actions.toggleNav(show)),
    setAuth: (auth) => dispatch(actions.setAuth(auth)),
    startHelp: () => dispatch(actions.startHelp())
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));


// WEBPACK FOOTER //
// ./src/components/Header.js